import { Wretcher } from "./wretcher";
var factory = Wretcher.factory;
factory["default"] = Wretcher.factory;
/* Export typescript types */
export { Wretcher } from "./wretcher";
/**
 * Return a fresh Wretcher instance.
 */
export default factory;
//# sourceMappingURL=index.js.map